module.exports = __webpack_public_path__ + "static/media/create_sections_creating_sections.f995bf5e.mov";